//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import BackendServices from "@/services/backend-services.js";

const DEFAULT_FORMAT = (value) => (value ? value : "N/A");

export default {
  name: "storesTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  beforeMount: async function () {
    let responseHL = await BackendServices.getStoreHierarchyLevels();
    this.hierarchyLevels = responseHL.data;
  },
  data: () => ({
    hierarchyLevels: [],
    separator: "horizontal",
    columns: [
      {
        name: "id",
        required: false,
        label: "#ID",
        align: "left",
        field: (row) => row.id,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "level-number",
        required: false,
        align: "left",
        label: "Nº Nível",
        field: (row) => row.level_id,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "designation-level",
        required: false,
        align: "left",
        label: "Designação Nível",
        field: (row) => row.desingationLevel,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "classification-level",
        required: false,
        align: "left",
        label: "Classificação Nível",
        field: (row) => row.name,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "classification-id-agregator",
        required: false,
        align: "left",
        label: "Classificação #ID Agregador",
        field: (row) => row.parent_id,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "classification-level-agregator",
        required: false,
        align: "left",
        label: "Classificação Nível Agregador",
        field: (row) => row.cla,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "designation-level-agregator",
        required: false,
        align: "left",
        label: "Designação Nível Agregador",
        field: (row) => row.designationLevelAgregator,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
    ],
    filteredData: [],
  }),
  methods: {
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function () {
        this.data.forEach((e) => {
          e["desingationLevel"] = this.hierarchyLevels.find(
            (hl) => e.level_id === hl.id
          ).name;
          e["designationLevelAgregator"] =
            e.parent_id === null
              ? "N/A"
              : this.data.find((hle) => hle.id === e.parent_id).name;
          e["cla"] =
            e.parent_id === null
              ? "N/A"
              : this.data.find((hle) => hle.id === e.parent_id)
                  .desingationLevel;
        });
      },
    },
  },
};
